@if (rangeArray().length) {
  <div class="labels-container">
    @for (position of rangeArray(); track position; let index = $index) {
      @if (hasScaleQuestionLabelOnPosition(position) === false) {
        <div class="spacing">
          <!--spacing-->
        </div>
      }
      @if (hasScaleQuestionLabelOnPosition(position) === true) {
        <div
          class="label-position"
          [class.mobile-hidden]="
            index !== 0 && index !== rangeArray().length - 1
          "
          [class.first]="index === 0"
          [class.last]="index === rangeArray().length - 1"
        >
          <ion-label
            class="label"
            [class.first]="index === 0"
            [class.last]="index === rangeArray().length - 1"
          >
            {{ getScaleQuestionLabel(position) }}
          </ion-label>
        </div>
      }
    }
  </div>
}
